module.exports = __webpack_public_path__ + "static/img/logo.e4811b68.svg";